import React,{ useState, useEffect } from 'react';

import {
    Button
} from 'antd';

import {
    ArrowRightOutlined
} from '@ant-design/icons';

import MacImage1 from '../../images/modem-swap/mac-address-location-fig1.png';
import MacImage2 from '../../images/modem-swap/mac-address-location-fig2.png';
import ModemSyncImage1 from '../../images/modem-swap/modem-sync-fig1.png';
import ModemSyncImage2 from '../../images/modem-swap/modem-sync-fig2.png';
import ModemSyncImage3 from '../../images/modem-swap/modem-sync-fig3.png';

const siteDomain = headerVars.siteDomain;

function ModemUpgradeBenefits( { handleOpenQuestionModal, handleOpenQuestionModalSync } ) {
    return (
        <div id="modem-setup-component" className="modem-setup-component modem-upgrade-component">
            <h4>Upgrading the Network to DOCSIS 3.1</h4>
            <p>The rationale for this upgrade is outlined within the benefits and supporting webpages, documentation, and videos found below.</p>
            
            <h4 style={{ marginTop: '2rem' }}>Benefits</h4>
            <ul>
                <li>Reduced latency (improved network gaming performance and support for real-time applications like voice and video) </li>
                <li>Enhanced security features </li>
                <li>Support for faster speeds </li>
                <li>Increased energy efficiency </li>
                <li>Enhanced spectrum utilization/efficiency </li>
            </ul>

            <h4 style={{ marginTop: '2rem' }}>Supporting Webpages /Documentation </h4>
            <div className='upgrade-benefits-link-container'><ArrowRightOutlined style={{ color:'#1C4A12' }}/> <a style={{ fontWeight: 500, fontSize: '0.9rem' }} href="https://www.cablelabs.com/blog/how-docsis-3-1-reduces-latency-with-active-queue-management" target="_blank">How DOCSIS 3.1 Reduces Latency with Active Queue Management </a></div>
            <div className='upgrade-benefits-link-container'><ArrowRightOutlined style={{ color:'#1C4A12' }}/> <a style={{ fontWeight: 500, fontSize: '0.9rem' }} href="https://emea.technetix.com/our-vision/docsis3-1/" target="_blank">Upgrading your network to DOCSIS 3.1 </a></div>
            <div className='upgrade-benefits-link-container'><ArrowRightOutlined style={{ color:'#1C4A12' }}/> <a style={{ fontWeight: 500, fontSize: '0.9rem' }} href="https://www.netgear.com/assets/campaign/118858/images/docsis31whitepaper.pdf" target="_blank">DOCSIS 3.1 Technology Whitepaper </a></div>
            <div className='upgrade-benefits-link-container'><ArrowRightOutlined style={{ color:'#1C4A12' }}/> <a style={{ fontWeight: 500, fontSize: '0.9rem' }} href="https://blogs.cisco.com/sp/the-benefits-of-docsis-3-1" target="_blank">The Benefits of DOCSIS 3.1 </a></div>
            <div className='upgrade-benefits-link-container'><ArrowRightOutlined style={{ color:'#1C4A12' }}/> <a style={{ fontWeight: 500, fontSize: '0.9rem' }} href="https://www.youtube.com/watch?v=cCmIwWMn-os" target="_blank">Understanding the difference between DOCSIS 3.0 & 3.1 (video)</a></div>
            <div className='upgrade-benefits-link-container'></div>
        </div>
    )
}

export default ModemUpgradeBenefits